import { fromJS } from 'immutable';
import { SET_STATS_CLAIMS } from 'containers/HomePage/constants';
import { RESET_STORE } from 'containers/LoginPage/constants';

export interface StatsClaimsAction {
  type: string;
  statsClaims: any;
}

const initialState: any = fromJS({
  statsClaims: {},
});

const statsClaimsReducer = (
  state = initialState,
  action: StatsClaimsAction,
) => {
  switch (action.type) {
    case SET_STATS_CLAIMS:
      return state.set('statsClaims', fromJS(action.statsClaims));
    case RESET_STORE:
      return initialState;
    default:
      return state;
  }
};

export default statsClaimsReducer;
